import React, { useState, useEffect } from 'react';
import { Chip, TextField, Box, Autocomplete } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import './Chip.css';

function ChipInput({ value = [], onChange, teamMembers = [] }) {
  const [chips, setChips] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [showInput, setShowInput] = useState(false);

  useEffect(() => {
    if (value) {
      setChips(value);
    }
  }, [value]);

  const handleAddChip = (newChip) => {
    if (newChip && !chips.includes(newChip)) {
      const newChips = [...chips, newChip];
      setChips(newChips);
      onChange && onChange(newChips);
    }
    setShowInput(false);
    setInputValue('');
  };

  const handleDeleteChip = (chipToDelete) => {
    const newChips = chips.filter((chip) => chip !== chipToDelete);
    setChips(newChips);
    onChange && onChange(newChips);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 1,
        border: '1px solid #ccc',
        borderRadius: 1,
        padding: 0,
        maxWidth: '100%',
        overflow: 'hidden',
        minHeight: '2rem'
      }}>
      {chips.map((chip, index) => (
        <Chip
          key={`${index + 1}`}
          label={chip}
          onDelete={() => handleDeleteChip(chip)}
          deleteIcon={<CloseIcon sx={{ color: 'black', opacity: '1' }} />}
          sx={{
            backgroundColor: 'rgba(170, 210, 226, 1)',
            height: '24px',
            justifyContent: 'center'
          }}
        />
      ))}

      {showInput ? (
        <Autocomplete
          options={teamMembers}
          value={inputValue}
          onChange={(event, newValue) => handleAddChip(newValue)}
          inputValue={inputValue}
          onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
          onBlur={() => setShowInput(false)}
          renderInput={(params) => (
            <TextField {...params} variant="outlined" size="small" autoFocus />
          )}
          sx={{ width: '100%' }}
        />
      ) : null}

      {!showInput && (
        <Chip
          icon={<AddIcon sx={{ color: '#FFF !important' }} />}
          label="Add"
          clickable
          onClick={() => setShowInput(true)}
          sx={{
            cursor: 'pointer',
            marginLeft: 'auto',
            marginRight: '2px',
            color: 'rgba(255, 255, 255, 1)',
            backgroundColor: 'rgba(0, 92, 188, 1)',
            height: '24px',
            lineHeight: '24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        />
      )}
    </Box>
  );
}

export default ChipInput;
